import { startup } from "./lib";

import CookieNotification from "./index.svelte";

startup({ CookieNotification });
